import React from 'react';
import { Link } from 'react-router-dom';
import { useAppSettings } from '../lib/i18n';

const footerLinks = [
  { to: '/', label: 'Home' },
  { to: '/about', label: 'About Us' },
  { to: '/faq', label: 'FAQ' },
  { to: '/privacy', label: 'Privacy Policy' },
  { to: '/contact', label: 'Contact Us' },
];

export default function Footer() {
  const { t } = useAppSettings();

  return (
    <footer className="mt-16 border-t border-slate-200 bg-[#F7FAFC]">
      <div className="emi-wrap py-8">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-5">
          <div className="flex items-center gap-2">
            <div className="h-9 w-9 rounded-lg bg-[#0176D3] flex items-center justify-center">
              <span className="text-white font-bold text-base">E</span>
            </div>
            <span className="text-[#032D60] font-semibold text-lg">{t('app_name')}</span>
          </div>

          <nav className="flex flex-wrap items-center gap-x-5 gap-y-2">
            {footerLinks.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                className="text-sm text-slate-600 dark:text-slate-400 hover:text-[#0176D3] transition-colors"
              >
                {l.label}
              </Link>
            ))}
          </nav>
        </div>

        <div className="mt-6 pt-5 border-t border-slate-200 text-xs text-slate-500 dark:text-slate-500 flex flex-col sm:flex-row justify-between gap-1.5">
          <span>&copy; {new Date().getFullYear()} {t('app_name')}.</span>
          <span>For illustrative purposes only.</span>
        </div>
      </div>
    </footer>
  );
}
